(() => {
  const copy = {
    title: 'Your privacy matters',
    message: 'We use cookies to improve your experience, understand site use, and show relevant content. You can accept all cookies or continue with essential cookies only.',
    accept: 'Accept all',
    decline: 'Essential only',
    manage: 'Preferences'
  };

  const applyCopy = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return;

    const title = banner.querySelector('h1, h2, h3, [role="heading"]');
    const message = banner.querySelector('p');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs');

    if (title && title.textContent !== copy.title) title.textContent = copy.title;
    if (message && message.textContent !== copy.message) message.textContent = copy.message;
    if (accept && accept.textContent !== copy.accept) accept.textContent = copy.accept;
    if (decline && decline.textContent !== copy.decline) decline.textContent = copy.decline;
    if (manage && manage.textContent !== copy.manage) manage.textContent = copy.manage;
  };

  new MutationObserver(applyCopy).observe(document.documentElement, { childList: true, subtree: true });
  applyCopy();
})();
